export enum TimeFormatType {
  H24 = '24h',
  H12 = '12h',
}
